import Component from '../abstracts/Component';

export default class SwitcherListingComponent extends Component {
    
    get SELECTORS() {
        return {
            main: '[data-set-listing]',
            list: '[data-listing-type]',
            bartype: '[data-bar-type]'
        };
    }
    
    constructor() {
        super();
        this.defaultClass = 'default';
        this.variant2prdClass= 'variant';
        this.alternateMobileClass = 'alternate-mobile';
        this.activeLinkClass = 'active';
    }
    setInactiveTriggers(triggers){
        for(let trigger of triggers){
            trigger.classList.remove(this.activeLinkClass);
        }
    }
    handlerListing(){
        let triggers = document.querySelectorAll(this.SELECTORS.main);
        let bartypeEl = document.querySelector(this.SELECTORS.bartype);
        for(let trigger of triggers){
            trigger.addEventListener('click',()=>{
                this.setInactiveTriggers(triggers);
                trigger.classList.add(this.activeLinkClass);
                let listType = trigger.dataset.setListing;
                this.switchList(listType);
                if(listType=='folded'){
                    bartypeEl.dataset.barType= 'editorial';
                }
            })
        }
    }
    switchList(listType){
        let listSection = document.querySelector(this.SELECTORS.list);
        let isAlternate = listSection.dataset.listingType === 'alternate';
        let isAlternateMobile = listSection.dataset.listingType === 'alternate-mobile';
        if(listType==='variant'){
            listSection.classList.remove(this.defaultClass);
            listSection.classList.add(this.variant2prdClass);
        }else{
            listSection.classList.add(this.defaultClass);
            listSection.classList.remove(this.variant2prdClass);
        }
        if(isAlternate||isAlternateMobile){
          listSection.dataset.listingType = listType;
        }
    }
    alternateMobile(){
        const listSection = document.querySelector(this.SELECTORS.list);
        let isAlternate = listSection.dataset.listingType
        let isMobile = window.matchMedia('(max-width:767px)').matches;
        if(isMobile && isAlternate==='alternate'){
            console.log('mobile listing');
            listSection.dataset.listingType = this.alternateMobileClass;
        }
    }
    render() {
        if (document.querySelectorAll(this.SELECTORS.main).length) {
            this.handlerListing();
            this.alternateMobile();
        }
        let myName = this.constructor.name
        console.log(`[${myName}] Rendering..`);
    }
}
